import methods from '@/services/methods'

export default {
  usersList () {
    return methods.sendGet(`users`, null, {unprivilege: 'Settings', noHyptoLoader: true})
  },
  userDetails (id) {
    return methods.sendGet(`users/${id}`, null, {unprivilege: 'UserDetails'})
  },
  newUserAccess () {
    return methods.sendGet(`users/new`, null, {unprivilege: 'UserDetails'})
  },
  createUser (payload) {
    return methods.sendPost(`users`, payload)
  },
  updateUser (id, payload) {
    return methods.sendPut(`users/${id}`, payload)
  },
  deleteUser (id) {
    return methods.sendDelete(`users/${id}`)
  },
  activateUser (id) {
    return methods.sendPost(`users/${id}/activate`)
  },
  deActivateUser (id) {
    return methods.sendPost(`users/${id}/deactivate`)
  },
  validateUserToken (payload) {
    return methods.sendGet(`users/validate_token`, payload, {restrictToast: true})
  },
  verifyUser (payload) {
    return methods.sendPost(`users/verify`, payload)
  },
  resendInvitation (payload) {
    return methods.sendPost(`users/resend_invitation`, payload)
  },
  enable2FA (id) {
    return methods.sendPost(`users/${id}/enable_two_factor`)
  },
  disable2FA (id) {
    return methods.sendPost(`users/${id}/disable_two_factor`)
  },
  reset2FA (id) {
    return methods.sendPost(`users/${id}/reset_two_factor`)
  },
  destroySession (id, payload) {
    return methods.sendDelete(`users/${id}/destroy_session`, payload)
  }
}
